import React from 'react';
import {
  ArrayInput,
  ReferenceInput,
  required,
  FormDataConsumer,
  SelectInput,
  SimpleFormIterator,
  TextInput,
  useTranslate,
} from 'react-admin';
import { Grid } from '@material-ui/core';

const isRequired = [required()];

const Contacts = ({
  className = '',
  isValidated = false,
  source = 'contacts',
  hasDescription = false,
  columns = hasDescription ? 4 : 6,
  ...rest
}) => {
  const translate = useTranslate();

  return (
    <ArrayInput
      source={source}
      validation={isValidated ? isRequired : false}
      label=''
      {...rest}
    >
      <SimpleFormIterator>
        <FormDataConsumer>
          {({ scopedFormData, getSource }) => {
            return (
              <Grid container spacing={2}>
                <Grid item xs={columns}>
                  <ReferenceInput
                    source={getSource(
                      rest.record?.id ? 'contactType.id' : 'contactType'
                    )}
                    reference='contact-types'
                    validate={isRequired}
                    variant='outlined'
                    fullWidth
                    label={translate('resources.contacts.fields.contactType')}
                  >
                    <SelectInput />
                  </ReferenceInput>
                </Grid>
                <Grid item xs={columns}>
                  <TextInput
                    source={getSource('contact')}
                    validate={isRequired}
                    variant='outlined'
                    fullWidth
                    label={translate('resources.contacts.fields.contact')}
                  />
                </Grid>
                {hasDescription && (
                  <Grid item xs={columns}>
                    <TextInput
                      source={getSource('description')}
                      variant='outlined'
                      fullWidth
                      label={translate('resources.contacts.fields.description')}
                    />
                  </Grid>
                )}
              </Grid>
            );
          }}
        </FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
};

export default Contacts;
